import React from 'react';
import styled from '@xstyled/styled-components';
import Icon from '~/assets/icons/new_chevron.svg';
import IconX from '~/assets/icons/close.svg';
import { t } from 'ttag';

const ArrowIcon = styled(Icon)`
  transform: rotate(180deg);
  fill: black;
`;

const CloseIcon = styled(IconX)`
  transform: rotate(180deg);
  fill: black;
`;

const Button = styled.button`
  position: absolute;
  width: fit-content;
  height: fit-content;
  display: flex;
  z-index: 1;
  top: ${p => p.theme.space.lg};
  left: ${p => p.theme.space.lg};
  border: none;
  padding: 5px;
  background: transparent;
  border-radius: 4px;

  &:focus,
  &:focus-visible {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }
`;

export const CloseButton = ({
  onClick,
  ariaLabel,
  type = 'arrow',
  autoFocus = true,
  disabled = false
}: {
  onClick: () => void;
  type?: string;
  ariaLabel?: string;
  autoFocus?: boolean;
  disabled?: boolean;
}) => (
  <Button
    onClick={onClick}
    aria-label={ariaLabel || t`close`}
    tabIndex={0}
    className="closeBtn"
    role="button"
    autoFocus={autoFocus}
    disabled={disabled}
  >
    {type === 'arrow' ? (
      <ArrowIcon aria-hidden="true" focusable="false" />
    ) : (
      <CloseIcon aria-hidden="true" focusable="false" />
    )}
  </Button>
);
